// extracted by mini-css-extract-plugin
export default {"bloc":"vWY7hinFjgmhBwSC5RNm"};